module.exports = __webpack_public_path__ + "img/Categories_bg_01.09c02cb0.jpg";